/**
 * @generated SignedSource<<2a19d2576e5fec918254c632044d06d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssignHotelToPackageDialog_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HotelSearchSelect_data">;
  readonly " $fragmentType": "AssignHotelToPackageDialog_data";
};
export type AssignHotelToPackageDialog_data$key = {
  readonly " $data"?: AssignHotelToPackageDialog_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssignHotelToPackageDialog_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssignHotelToPackageDialog_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HotelSearchSelect_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "413e9bd278895207f86928d380b6ec5a";

export default node;
